import template from './swag-cms-extensions-custom-form-element-text.html.twig';

export default {
    template,

    props: {
        field: {
            type: Object,
            required: true,
        },
    },
}
